import type { OrdersOverviewSort } from './OrdersOverview.types';
import { LabsGqlLabOrderSortKey } from '@orthly/graphql-schema';

export const OrdersOverviewDefaultSort: OrdersOverviewSort = { key: LabsGqlLabOrderSortKey.UpdatedAt, asc: false };
